module.exports = {"131121100":"枣强镇","131121101":"恩察镇","131121102":"大营镇","131121103":"嘉会镇","131121104":"马屯镇","131121105":"肖张镇","131121106":"张秀屯镇","131121107":"新屯镇","131121108":"唐林镇","131121202":"王均乡","131121204":"王常乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131121.json
// module id = 332
// module chunks = 0